module.exports = __webpack_public_path__ + "static/media/ConfigureBranding14Sept2020.d7997a20.gif";